// Central content + placeholders for Million-Air A/C & Heating.
// Swap placeholder links / hours as they become available.

export const CONTACT = {
  phone: "512-740-4818",
  phoneHref: "tel:5127404818",
  email: "service@millionairhvac.com",
  emailHref: "mailto:service@millionairhvac.com",
  serviceArea:
    "Proudly serving Round Rock and the greater Austin-Round Rock-San Marcos area within a 50-mile radius.",
};

// Pending links, wired as placeholders for now.
export const LINKS = {
  FINANCING_LINK: "https://www.synchrony.com/mmc/M9221849700?sitecode=acewel402",
  GOOGLE_REVIEW_LINK: "https://g.page/r/CRMVZd_oVD_nEBM/review",
  BBB_LINK: "{BBB_LINK}",
};

export const BUSINESS_HOURS = "8:00 to 5:00, Monday to Friday. Closed weekends except emergencies.";

export const NAV_ITEMS = [
  { id: "home", label: "Home" },
  { id: "services", label: "Services" },
  { id: "why", label: "Why Million-Air" },
  { id: "reviews", label: "Reviews" },
  { id: "contact", label: "Contact" },
];

export const TRUST = [
  "A+ BBB Rating",
  "BBB Accredited since 2005",
  "American Standard Dealer",
  "Serving Central Texas for more than two decades",
];

export const NAV_URL = process.env.PUBLIC_URL || "";

export const SERVICE_OPTIONS = ["Cooling", "Heating", "Maintenance", "Other"];
